export default __webpack_public_path__ + "static/media/fb-icon.676552de.svg";